import * as React from "react";
const SvgSemrush = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FF642D",
  d: "M19.887 11.83c0 .426-.218.496-.758.496-.575 0-.68-.096-.74-.532-.114-1.106-.863-2.047-2.117-2.151-.401-.035-.497-.183-.497-.68 0-.461.07-.679.427-.679 2.178.009 3.685 1.76 3.685 3.545m3.17 0c0-3.32-2.247-6.83-7.439-6.83H5.305c-.21 0-.34.105-.34.296 0 .105.079.2.148.253q.564.444 1.664.993c.714.357 1.272.592 1.83.819.234.095.322.2.322.33 0 .184-.131.297-.384.297H.357C.113 7.988 0 8.145 0 8.3c0 .131.044.244.157.358.662.696 1.725 1.533 3.266 2.5 1.35.844 3.023 1.76 4.356 2.395.226.104.296.226.296.357-.009.148-.122.27-.383.27H3.937c-.209 0-.33.113-.33.288 0 .095.078.217.182.313.854.775 2.221 1.62 4.042 2.396 2.43 1.036 4.895 1.655 7.665 1.655 5.253 0 7.561-3.929 7.561-7.004m-6.855 4.712c-2.578 0-4.73-2.1-4.73-4.713 0-2.578 2.152-4.643 4.73-4.643 2.648 0 4.712 2.065 4.712 4.643-.008 2.614-2.073 4.713-4.712 4.713"
}));
export default SvgSemrush;
//# sourceMappingURL=Semrush.js.map